import React from 'react';
const AppVersion = () => {
    return (
        <span className="fixed bottom-0 left-0 text-white text-base text-right z-50">
            {process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : ''}
        </span>
    );
};
export default AppVersion;
